module.exports = __webpack_public_path__ + "img/changeStonegroup-2@2x.9a2e330.png";